/**
 * O QUE TODO PAPEL DESTE SISTEMA TEM EM COMUM.
 *
 * O romaneio da despesca foi o primeiro documento a sair da impressora; a guia
 * de movimentação é o segundo. Os dois precisam das mesmas peças — a data por
 * extenso, o campo rotulado que vira risco quando está vazio, o carimbo de
 * emissão, os dois botões de saída — e copiar isso de um arquivo para o outro
 * é garantir que um dia a data se escreva de dois jeitos.
 *
 * O que NÃO mora aqui é a estrutura do documento em si: cabeçalho, tabelas,
 * fecho. Cada papel tem o seu leitor e o seu propósito, e a lição do romaneio
 * vale para os dois — FORMULÁRIO NÃO É DOCUMENTO, e um documento também não é
 * o outro.
 */

import { useState } from 'react'

/** «20 de setembro de 2026» — o jeito de escrever data num documento. */
export function porExtenso(iso: string): string {
  const MESES = [
    'janeiro', 'fevereiro', 'março', 'abril', 'maio', 'junho',
    'julho', 'agosto', 'setembro', 'outubro', 'novembro', 'dezembro',
  ]
  const [a, m, d] = iso.slice(0, 10).split('-')
  const mes = MESES[Number(m) - 1] ?? ''
  return `${Number(d)} de ${mes} de ${a}`
}

function isoDe(d: Date): string {
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`
}

function hora(d: Date): string {
  return `${String(d.getHours()).padStart(2, '0')}h${String(d.getMinutes()).padStart(2, '0')}`
}

/** «Emitido em 23 de setembro de 2026 às 14h05» — o carimbo do rodapé. */
export function emitidoEm(): string {
  const agora = new Date()
  return `Emitido em ${porExtenso(isoDe(agora))} às ${hora(agora)}`
}

export function Dado({ rotulo, valor, largo }: { rotulo: string; valor: string; largo?: boolean }) {
  return (
    <div className={largo ? 'rp-dado largo' : 'rp-dado'}>
      <div className="rp-dado-rotulo">{rotulo}</div>
      {/* Campo vazio vira risco, e não branco: num papel assinado, espaço em
          branco é convite para alguém preencher depois. */}
      <div className="rp-dado-valor">{valor.trim() === '' ? '—' : valor}</div>
    </div>
  )
}

/**
 * As duas saídas do papel, e as duas funcionam sem sinal, porque o conteúdo
 * já está no aparelho: a planilha para o Excel do outro lado, e a impressão do
 * navegador — que no celular é «Imprimir → Salvar em PDF», e é assim que o PDF
 * sai sem carregar uma biblioteca de trezentos kilobytes que ninguém vai
 * manter.
 *
 * `aoPlanilha` devolve `false` quando o navegador não deixou baixar; aí a tela
 * aponta para a impressão, que é o outro caminho.
 */
export function SaidasDePapel({ aoPlanilha }: { aoPlanilha: () => boolean }) {
  const [aviso, setAviso] = useState<string | null>(null)

  return (
    <div className="papel-saidas">
      <button
        type="button"
        className="discreto"
        onClick={() => {
          setAviso(aoPlanilha() ? null : 'Este navegador não deixou baixar. Use Imprimir e salve em PDF.')
        }}
      >
        ↓ planilha (Excel)
      </button>
      <button type="button" className="discreto" onClick={() => window.print()}>
        ⎙ imprimir / PDF
      </button>
      {aviso && <p className="secundario">{aviso}</p>}
      {/* O navegador carimba data e endereço no alto e no pé da folha por
          conta própria, e nenhuma regra de estilo alcança isso — quem desliga
          é quem imprime. Dizer onde fica o botão poupa a descoberta. */}
      <p className="secundario">
        Na janela de impressão, desmarque <strong>Cabeçalhos e rodapés</strong> para a folha
        sair limpa.
      </p>
    </div>
  )
}
